<div class="container">
	<div class="header">
		<div class="header__content">
			<h1>Privacy Policy</h1>
		</div>
	</div>
</div>
<div class="container privacy-policy">
	<div class="body">
		<ol type="1">
			<li>
				<p class="fw-bold">Privacy Policy</p>
				<ol type="a">
					<li>
						<p>
							This Privacy Policy describes the policies and procedures on the
							collection, use, and disclosure of the information collected from
							using the Application or the Services included in the Application,
							in which describes your rights and how the law protects you as a
							user of the Application.
						</p>
					</li>
					<li>
						<p>
							By using the Application and the Services that it provides, you
							agree to the collection and use of information in accordance with
							this Privacy Policy.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Definitions</p>
				<ol type="a">
					<li>
						<p>
							<span class="fw-medium">Account</span> means the account
							authenticated by username and password, to access the Application.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Affiliates</span> means the company’s
							parent company and any subsidiaries, joint venture partners or
							other companies that are under the company’s control or that are
							under common control with the company.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Application</span> means the software
							program provided by {{ customData.provenance }} downloaded by you
							on any electronic device, named CS website.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Cookies</span> are small files that are
							placed on your computer, website device or any other device by a
							website, containing the details of your browsing history on that
							website among its many uses.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Device</span> means any device that can
							access the Service such as a computer, a cell phone or a digital
							tablet.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Profile</span> means the profile created
							by the Client and Employee that may include personal information
							of the Client, Employee, and Staff.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Service</span> means any services provided
							by {{ customData.provenance }} through the Application;
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Service Provider</span> means any natural
							or legal person who processes the data on behalf of
							{{ customData.provenance }}. It refers to third-party companies or
							individuals employed by the Company to facilitate the Service, to
							provide the Service on behalf of the Company, to perform services
							related to the Service or to assist the Company in analyzing how
							the Service is used.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Usage Data</span> refers to data collected
							automatically, either generated by the use of the website or from
							the Service infrastructure itself (for example, the duration of a
							page visit).
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Staff</span> means a person engaged or
							employed by {{ customData.provenance }};
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">User</span> refers to any individual or
							entity that uses any aspect of the Application and/or the
							Services.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Website</span>
							{{ customData.websiteMeans }}
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">You</span> or
							<span class="fw-medium">your</span> means the person who (or the
							entity on behalf of whom you are acting) that is agreeing to these
							Terms.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">User Content and Submissions</p>
				<ol type="a">
					<li>
						<p>
							You understand that all User Content is the sole responsibility of
							the person from which such User Content originated. <br />
							<i
								>“You understand that all User Content is the sole
								responsibility of the person from which such User Content
								originated. This also includes personal information submitted
								during the HR onboarding process, such as employee names,
								contact details, employment history, and other relevant
								information.”
							</i>
						</p>
					</li>
					<li>
						<p>
							You understand and acknowledge that all information provided by
							you, your {{ customData.provenance }} Website Profile and/or
							account information shall be stored in
							{{ customData.provenance }} Databases and/or
							{{ customData.provenance }} Website Application.
						</p>
					</li>
					<li>
						<p>
							We may ask you to provide us with certain personal information
							that can be used to contact or identify you. Personal information
							may include, but is not limited to:
						</p>
						<ol type="i">
							<li>
								<p>Name;</p>
							</li>
							<li>
								<p>Email Address;</p>
							</li>
							<li>
								<p>Contact Number;</p>
							</li>
							<li>
								<p>Address;</p>
							</li>
							<li>
								<p>Marital Status;</p>
							</li>
							<li>
								<p>Current Salary;</p>
							</li>
							<li>
								<p>Expected Salary;</p>
							</li>
							<li>
								<p>Work Experience</p>
							</li>
							<li>
								<p>Education;</p>
							</li>
							<li>
								<p>Social Media;</p>
							</li>
							<li>
								<p>Character References;</p>
							</li>
							<li>
								<p>Work Location Preferences; and</p>
							</li>
							<li>
								<p>Skills & Specialization.</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Usage Data</p>
				<ol type="a">
					<li>
						<p>
							When using the Services of the Application, Usage Data is
							collected automatically, this includes, but not limited to;
						</p>
						<ol type="i">
							<li>
								<p>
									website device’s unique ID, IP address, and operating system;
								</p>
							</li>
							<li>
								<p>unique device identifiers and other diagnostic data.</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Use of Personal Information</p>
				<ol type="a">
					<li>
						<p>
							To provide features of our Application and to operate our talent
							business, we may collect and use information such as:
						</p>
						<ol type="i">
							<li>
								<p>
									To screen and identify potential candidates for a job position
									to fulfill hiring needs;
								</p>
							</li>
							<li>
								<p>
									To screen candidates and help recruiters determine if they are
									qualified for a job; and
								</p>
							</li>
							<li>
								<p>
									To verify employee identity, process employment contracts and
									benefits, manage employee records, other HR processes,
									compliance with legal and regulatory requirements.
								</p>
							</li>
						</ol>
					</li>
					<li>
						To promote your skills, introduce you to potential Clients or other
						requirements as is needed to operate our talent business and enable
						recruitment outcomes we may collect, share, and market your
						information.
					</li>
					<li>
						<p>
							Your personal data will be used to send you automated email
							updates regarding the status of your job applications. These
							updates are designed to keep you informed about the progress of
							your applications through different recruitment stages or
							pipelines.
						</p>
					</li>
					<li>
						<p>
							Upon account verification, we may use your personal information to
							send you marketing communications about job opportunities and
							related services. You have the right to opt out of these
							communications at any time by following the unsubscribe
							instructions included in the emails.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Transfer of Personal Information</p>
				<ol type="a">
					<li>
						<p>
							We may share your personal information in the following
							situations:
						</p>
						<ol type="i">
							<li>
								<p>
									<span class="fw-medium">With our Affiliates</span>: We may
									share your information with our Affiliates, including parent
									and subsidiaries, in which they must comply with Privacy
									Policy when sharing information.
								</p>
							</li>
							<li>
								<p>
									<span class="fw-medium"
										>With other users including potential Clients</span
									>: when you share personal information such information may be
									viewed by all users, including potential Clients and may be
									publicly distributed outside, access control is limited only
									to the functionalities of the Service that are only available
									to you.
								</p>
							</li>
							<li>
								<p>
									<span class="fw-medium">With your consent</span>: We may
									disclose your personal information for any other purpose with
									your consent.
								</p>
							</li>
						</ol>
					</li>
					<li>
						Your consent to this Privacy Policy and/or your submission of such
						information represents your agreement to that transfer.
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Retention of Your Personal Information</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} will retain the information collected
							for as long as it is necessary for the purposes set out in this
							Privacy Policy;
						</p>
					</li>
					<li>
						<p>
							The data obtained from the Content, Profile, Database or
							Application shall not be kept longer than is necessary for the
							fulfillment of the purposes set out in this Section. In this
							respect, you agree and undertake to delete, destroy and/or purge
							such data or any derivatives thereof from your records.
						</p>
					</li>
					<li>
						<p>
							You understand and acknowledge that you have no ownership rights
							in your account and that if you cancel your Account or your
							Account is terminated, all your account information from Database
							or Website, including your Profile will remain in the Database at
							the discretion of {{ customData.provenance }}. In addition, the
							Employees and/or the Clients may retain saved copies of your
							information or Profile.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Third-Party Providers</p>
				<ol type="a">
					<li>
						<p>third parties may retain cached copies of User information;</p>
					</li>
					<li>
						<p>
							We may share your information with third parties that perform
							services for us or on our behalf, including data analysis, email
							delivery, hosting services, and customer service.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Links to Other Applications</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} is not responsible for content on any
							site outside the {{ customData.provenance }} Website Application.
							We strongly advise you to review the Privacy Policy of every site
							you visit.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Disclosure of Personal Information</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} will disclose required information to
							potential Clients as is needed to operate our talent business and
							enable recruitment outcomes.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} may collect certain User information
							and may contact Users periodically in accordance with the terms of
							this Privacy Policy. In addition,
							{{ customData.provenance }} reserves the right to comply, in its
							sole discretion, with legal requirements, requests from law
							enforcement agencies or requests from government entities, even to
							the extent that such compliance may require disclosure of certain
							User information.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Security of Personal Information</p>
				<ol type="a">
					<li>
						<p>
							Businesses can ensure data confidentiality by controlling who has
							access to non-public information, documents, files, etc. Access
							control should always be based on the principle of least
							privilege, which means that you should only grant access to data
							on a need-to-know basis.
						</p>
					</li>
					<li>
						<p>
							If {{ customData.provenance }} has reason to believe that there is
							likely to be a breach of security or misuse of the Application, we
							may require you to change your password or we may suspend your
							account immediately. <br />
							<i
								>If {{ customData.provenance }} has reason to believe that there
								is likely to be a breach of security or misuse of the
								Application, we may require you to change your password or we
								may suspend your account immediately. Specific security measures
								will be implemented to protect personal data collected through
								the HR onboarding app.</i
							>
						</p>
					</li>
					<li>
						<p>
							You shall be strictly liable and/or responsible for all uses of
							your Account registrations and passwords, whether or not
							authorized by you.
						</p>
					</li>
					<li>
						<p>
							As a result of your loss of your password or the misuse of the
							Application:
						</p>
						<ol type="i">
							<li>
								<p>
									all losses or damages incurred thereby shall be borne by you;
									and
								</p>
							</li>
							<li>
								<p>
									you shall fully indemnify {{ customData.provenance }} should
									the Application suffer any loss, damage or payment of fine
									from any regulatory or legal authority.
								</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Modification to Privacy Policy</p>
				<ol type="a">
					<li>
						<p>
							We reserve the right, at our discretion, to change the Policy from
							time to time. An email will be sent out if changes to the Policy
							have been applied. Please check the Policy periodically for
							changes;
						</p>
					</li>
					<li>
						<p>
							Your access to the {{ customData.provenance }} Website Application
							may be occasionally restricted and the Service may be unavailable
							in order to allow for repairs, maintenance or the introduction of
							new content, facilities or services. We will attempt to restore
							access and/or service as soon as we reasonably can.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} may terminate, suspend, update, alter
							or supplement, at its sole discretion, all or any part of the
							Application at any time. By permitting access to the Application,
							{{ customData.provenance }} does not convey any interest in or to
							the Content or any other {{ customData.provenance }} property or
							Services. All right, interest in and to the
							{{ customData.provenance }} Website Application is and shall
							remain in {{ customData.provenance }}.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Contact Information</p>
				<ol type="a">
					<li>
						<p>
							If you have any queries please contact us
							<a class="fw-medium" [href]="customData.mailToRecruiterEmail">{{
								customData.recruitEmail
							}}</a
							>.
						</p>
					</li>
					<li>
						<p>
							We will send notice to you at the address submitted by you or to
							such other address as {{ customData.provenance }} reasonably
							determines is an appropriate address for you.
						</p>
					</li>
				</ol>
			</li>
		</ol>
	</div>
</div>
